export default __webpack_public_path__ + "static/media/FlyingFrog28.397bca36.png";